import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getURLByRouteName } from "../../../../../utils/routes";
import "./index.css";

const CustomRadioButtonTerms = (props) => {
  const { onChange, term, keyword_term } = props;
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    // if (
    //   isRequired &&
    //   (errorFieldsPublicForm === true || errorFieldsProfessionalForm === true)
    // )
    return () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="element">
      <div className="container-pair-radio-button">
        <div className="pair-radio-button">
          <div
            className={`${isSelected ? "selected-radio" : "radio"}`}
            onClick={() => {
              setIsSelected(!isSelected);
              onChange(!isSelected);
            }}
          >
            <div className={`${isSelected ? "selected-radio-content" : ""}`} />
          </div>
          <p className="terms">
            {term}
            <Link target='_blank' rel='noopener noreferrer' className="term_keyword" to={getURLByRouteName('noticeOfPrivacy')}>
              {keyword_term}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  settings: state.settings,
});

export default connect(mapStateToProps)(CustomRadioButtonTerms);
